import { USER_LOGGED_OUT, USER_LOGGED_SUCCESS } from "actions/auth";
import { USER_LOGGED_ERROR } from "../actions/auth";

export default function auth(state={}, action={}) {
  switch (action.type) {
    case USER_LOGGED_SUCCESS:
      return { error: null, token: action.token };
    case USER_LOGGED_ERROR:
      return { error: action.error, token: null };
    case USER_LOGGED_OUT:
      return {};
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/auth.js